/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EventArray } from '../models/EventArray'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class EventsService {
  /**
   * 📱 Store a list of recorded events
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static storeEvents(requestBody?: EventArray): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/events/storeMany',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `The request was unauthenticated`,
        422: `Request validation failed`,
      },
    })
  }
}
